import GoToTop from '@atoms/GoToTop';
import Image from '@atoms/Image';
import PortableText from '@atoms/PortableText';
import Tag from '@atoms/Tag';
import AboutMeCard from '@molecules/AboutMeCard';
import ColumnLayout from '@molecules/ColumnLayout';
import TableOfContents from '@molecules/TableOfContents';
import InstagramPreview from '@organisms/InstagramPreview';
import RelatedArticles from '@organisms/RelatedArticles';
import type { ReactElement } from 'react';

import { Ad } from '@/components/store/components/Ad/Ad';
import { MobileCardsWrapper } from '@/styles/GlobalStyle';

import {
  ContentWrapper,
  Date,
  ImageWrapper,
  PostContentWrapper,
  PreviewButton,
  TagsWrapper,
  TopSectionWrapper,
} from './ArticlePageView.styled';
import type { ArticlePageViewProps } from './ArticlePageView.types';

export const ArticlePageView = ({
  tags,
  publishDate,
  mainImage,
  columnLayout,
  relatedArticles,
  title,
  breadcrumbs,
  postContent,
  tableOfContents,
  preview = false,
  portableTextComponents,
}: ArticlePageViewProps): ReactElement => (
  <>
    <ColumnLayout {...columnLayout} breadcrumbs={breadcrumbs}>
      <ContentWrapper className="mainContent">
        <TopSectionWrapper>
          <TagsWrapper>
            {tags?.map(tag => (
              <Tag key={tag.title} link={tag.link} title={tag.title} />
            ))}
          </TagsWrapper>
          <Date>{publishDate}</Date>
        </TopSectionWrapper>
        <h1>{title}</h1>
        <ImageWrapper>
          {mainImage.src && (
            <Image
              {...mainImage}
              fill
              sizes="(max-width: 991px) 100vw, 700px"
              style={{ maxWidth: '100%', objectFit: 'cover' }}
              priority
            />
          )}
        </ImageWrapper>
        {tableOfContents.length > 1 && (
          <TableOfContents headingsList={tableOfContents} />
        )}
        <PostContentWrapper>
          <PortableText
            value={postContent}
            additionalComponents={portableTextComponents}
          />
          <Ad
            alt="Przewodnik po Teneryfie – atrakcje, plan podróży, planer i porady️."
            destination="/sklep/teneryfa"
            src="/static/images/teneryfa/ad-teneryfa.jpg"
            srcWebp="/static/images/teneryfa/ad-teneryfa.webp"
            mobileOnly
            isSticky={false}
          />
        </PostContentWrapper>
        {/* comments hidden temporarily */}
      </ContentWrapper>
      <RelatedArticles {...relatedArticles} />
      <MobileCardsWrapper>
        <AboutMeCard />
        <InstagramPreview {...columnLayout.instagramFeed} />
      </MobileCardsWrapper>
    </ColumnLayout>
    {preview && (
      <PreviewButton href="/api/exit-preview">
        Wyjdź z trybu podglądu
      </PreviewButton>
    )}
    <GoToTop />
  </>
);
